module.exports = __webpack_public_path__ + "static/img/jinghaoIcon.a92968c3.svg";